import React from 'react';
import { MyScorecard } from './MyScorecard';

export const MyScorecardFactory = ({ widgetInformation }) => {
  const title = widgetInformation.config.title;
  return <MyScorecard title={title} />;
};
